import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getSubscriptionsWithMopDetails } from './fetchSubscription';
import { client as PricingSDKClient, ErrorType, ProductType } from '@chegg/pricing-sdk';
import { VendorType } from '../../gql/globalTypes';
import { UserSubscriptionAction } from './product-recommendation-dgs.types';
import { fetchLatestPricing } from './fetchLatestPricing';
import { legacyCatalogItemType, legacySubscriptionStatus } from '../SubscriptionUtil/legacy/LegacySubscriptionHelpers';
import { formatCurrency } from '../currencyFormatter';
import { sendCommerceNewRelicError } from '../NewRelicUtils';
import { ProjectName } from './constants';
import configureApolloForCommerce from '../../gql/configureApolloForCommerce';
import { getEnvironmentByCheggBaseUrl, isProd } from '../../common/helper';
import { captureError, Severity, TeamInfo } from '@chegg/observability';
import { USE_PRICING_ERROR_LOCATION } from '../../hooks/usePricingAsync';
import { PRODUCT_TYPE_TO_OFFER_ID } from '../../common/interfaces';
import { mapAccountType } from './nextInteractionUtil/getMopAccountType';
import { getBillingAddress } from './nextInteractionUtil/getBillingAddress';
import { getMopDescription } from './nextInteractionUtil/getMopDescription';
import { getTotalRenewalPrice } from './nextInteractionUtil/getTotalRenewalPrice';
/**
 * Replacement for the getNextInteraction method of Pricing SDK, which aggregates
 * the user's product information and method of payment details.
 * @param request GetNextInteractionRequest
 * @returns Promise<GetNextInteractionResponse>
 */
var getNextInteraction = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var request, apolloClient, teamName, hostname, pricingData, vendorType, _request$authorizePar, cheggGraphQLUrl, cheggBaseUrl, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          request = _ref.request, apolloClient = _ref.apolloClient, teamName = _ref.teamName, hostname = _ref.hostname;
          pricingData = request.pricingData;
          vendorType = pricingData.vendorType;
          if (!(vendorType === VendorType.RECURLY)) {
            _context.next = 10;
            break;
          }
          _request$authorizePar = request.authorizeParams, cheggGraphQLUrl = _request$authorizePar.cheggGraphQLUrl, cheggBaseUrl = _request$authorizePar.cheggBaseUrl;
          configureApolloForCommerce(isProd(getEnvironmentByCheggBaseUrl(cheggBaseUrl || cheggGraphQLUrl || '')), hostname);
          _context.next = 8;
          return nextInteractionResponse(request, apolloClient, teamName);
        case 8:
          response = _context.sent;
          return _context.abrupt("return", response);
        case 10:
          _context.next = 12;
          return PricingSDKClient.nextInteractionApi.getNextInteraction(request);
        case 12:
          return _context.abrupt("return", _context.sent);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getNextInteraction(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Converts a GetNextInteractionRequest to a DCO1ClickReturnPayload, a property
 * of GetNextInteractionResponse.data.
 * @param request GetNextInteractionRequest
 * @returns DCO1ClickReturnPayload
 */
var createOrderManagementDCO1ClickReturnPayload = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(request, apolloClient, teamName) {
    var successUrl, errorUrl, authorizeParams, pricingData, hostAnnotations, _request$authorizePar2, cheggGraphQLUrl, cheggBaseUrl, externalId, eligibility, productFamily, subsWithMop, orderDetails, _eligibility$price$it, _eligibility$price, _eligibility$price$pr, _eligibility$price2, _eligibility$price$ex, _eligibility$price3, _orderDetails$lineIte, finalActions, transformedPricingData;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          successUrl = request.successUrl, errorUrl = request.errorUrl, authorizeParams = request.authorizeParams, pricingData = request.pricingData, hostAnnotations = request.hostAnnotations, _request$authorizePar2 = request.authorizeParams, cheggGraphQLUrl = _request$authorizePar2.cheggGraphQLUrl, cheggBaseUrl = _request$authorizePar2.cheggBaseUrl;
          externalId = pricingData.externalId, eligibility = pricingData.eligibility, productFamily = pricingData.productFamily;
          _context2.next = 4;
          return getSubscriptionsWithMopDetails(apolloClient, teamName, getEnvironmentByCheggBaseUrl(cheggBaseUrl || cheggGraphQLUrl || ''));
        case 4:
          subsWithMop = _context2.sent;
          orderDetails = myLatestSubscriptionsV1ToOrderDetails(subsWithMop);
          if (!(orderDetails && orderDetails.mopDetails && orderDetails.details)) {
            _context2.next = 10;
            break;
          }
          finalActions = eligibility.finalActions;
          transformedPricingData = _objectSpread(_objectSpread({}, pricingData), {}, {
            eligibility: _objectSpread(_objectSpread({}, pricingData.eligibility), {}, {
              order: orderDetails
            })
          });
          return _context2.abrupt("return", {
            items: [{
              externalId: externalId,
              catalogItemId: (_eligibility$price$it = (_eligibility$price = eligibility.price) === null || _eligibility$price === void 0 ? void 0 : _eligibility$price.itemDetails.id) !== null && _eligibility$price$it !== void 0 ? _eligibility$price$it : '',
              pricingId: (_eligibility$price$pr = (_eligibility$price2 = eligibility.price) === null || _eligibility$price2 === void 0 ? void 0 : _eligibility$price2.pricingLogId) !== null && _eligibility$price$pr !== void 0 ? _eligibility$price$pr : '',
              experiment: (_eligibility$price$ex = (_eligibility$price3 = eligibility.price) === null || _eligibility$price3 === void 0 ? void 0 : _eligibility$price3.experiment) !== null && _eligibility$price$ex !== void 0 ? _eligibility$price$ex : 'BASE',
              catalogItemSource: 'RECURLY',
              productName: request.productName,
              quantity: 1
            }],
            successUrl: successUrl,
            errorUrl: errorUrl,
            externalId: externalId,
            action: finalActions && finalActions.length > 0 ? finalActions[0] : '',
            authorization: authorizeParams,
            eligibility: transformedPricingData,
            mopDetails: orderDetails.mopDetails,
            hostAnnotations: hostAnnotations,
            price: null,
            orderLineId: (_orderDetails$lineIte = orderDetails.lineItem) === null || _orderDetails$lineIte === void 0 ? void 0 : _orderDetails$lineIte.id,
            orderDetails: orderDetails.details,
            productType: productFamily
          });
        case 10:
          return _context2.abrupt("return", null);
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function createOrderManagementDCO1ClickReturnPayload(_x2, _x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Converts a GetNextInteractionRequest to a DCO1ClickReturnPayload, a property
 * of GetNextInteractionResponse.data.
 * @param request GetNextInteractionRequest
 * @returns DCO1ClickReturnPayload
 */
var createCheckoutDCO1ClickReturnPayload = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(request, apolloClient) {
    var _eligibility$price$it2, _eligibility$price4, _eligibility$price$pr2, _eligibility$price5, _eligibility$price$ex2, _eligibility$price6;
    var successUrl, errorUrl, authorizeParams, pricingData, hostAnnotations, _request$pricingData, countryCode, externalId, eligibility, productFamily, finalActions, price, annotation, finalAction, products, items, _request$authorizePar3, cheggGraphQLUrl, cheggBaseUrl, environment, response, _response$data$eligib, _response$data$eligib2, _response$data$eligib3, _response$data$eligib4, _response$data$eligib5, _response$data$eligib6;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          successUrl = request.successUrl, errorUrl = request.errorUrl, authorizeParams = request.authorizeParams, pricingData = request.pricingData, hostAnnotations = request.hostAnnotations;
          _request$pricingData = request.pricingData, countryCode = _request$pricingData.countryCode, externalId = _request$pricingData.externalId, eligibility = _request$pricingData.eligibility, productFamily = _request$pricingData.productFamily, finalActions = _request$pricingData.eligibility.finalActions, price = _request$pricingData.price;
          annotation = eligibility.annotation;
          finalAction = finalActions !== null && finalActions !== void 0 && finalActions.length ? finalActions[0] : ''; // Set products and items arrays with CS data
          products = [request.pricingData];
          items = [{
            externalId: externalId,
            catalogItemId: (_eligibility$price$it2 = (_eligibility$price4 = eligibility.price) === null || _eligibility$price4 === void 0 ? void 0 : _eligibility$price4.itemDetails.id) !== null && _eligibility$price$it2 !== void 0 ? _eligibility$price$it2 : '',
            pricingId: (_eligibility$price$pr2 = (_eligibility$price5 = eligibility.price) === null || _eligibility$price5 === void 0 ? void 0 : _eligibility$price5.pricingLogId) !== null && _eligibility$price$pr2 !== void 0 ? _eligibility$price$pr2 : '',
            experiment: (_eligibility$price$ex2 = (_eligibility$price6 = eligibility.price) === null || _eligibility$price6 === void 0 ? void 0 : _eligibility$price6.experiment) !== null && _eligibility$price$ex2 !== void 0 ? _eligibility$price$ex2 : 'BASE',
            catalogItemSource: 'RECURLY',
            productName: request.productName,
            annotation: _objectSpread(_objectSpread({}, request.itemAnnotations), annotation),
            quantity: 1
          }]; // Fetch CSP data if the user is in the Recurly upsell flow
          if (!(countryCode === 'US' && productFamily === ProductType.CHEGG_STUDY && [UserSubscriptionAction.RESUBSCRIBE.toString()].includes(finalAction))) {
            _context3.next = 19;
            break;
          }
          _request$authorizePar3 = request.authorizeParams, cheggGraphQLUrl = _request$authorizePar3.cheggGraphQLUrl, cheggBaseUrl = _request$authorizePar3.cheggBaseUrl;
          environment = getEnvironmentByCheggBaseUrl(cheggBaseUrl || cheggGraphQLUrl || '');
          _context3.prev = 9;
          _context3.next = 12;
          return fetchLatestPricing({
            apolloClient: apolloClient,
            environment: environment,
            inputs: {
              countryCode: countryCode,
              offerId: PRODUCT_TYPE_TO_OFFER_ID[ProductType.CHEGG_STUDY_PACK],
              productCode: ProductType.CHEGG_STUDY_PACK,
              openToUpgrade: false
            }
          });
        case 12:
          response = _context3.sent;
          // Add CSP data into products and items arrays
          if (response.data) {
            products.push(response.data);
            items.push({
              externalId: response.data.externalId,
              catalogItemId: (_response$data$eligib = (_response$data$eligib2 = response.data.eligibility.price) === null || _response$data$eligib2 === void 0 ? void 0 : _response$data$eligib2.itemDetails.id) !== null && _response$data$eligib !== void 0 ? _response$data$eligib : '',
              pricingId: (_response$data$eligib3 = (_response$data$eligib4 = response.data.eligibility.price) === null || _response$data$eligib4 === void 0 ? void 0 : _response$data$eligib4.pricingLogId) !== null && _response$data$eligib3 !== void 0 ? _response$data$eligib3 : '',
              experiment: (_response$data$eligib5 = (_response$data$eligib6 = response.data.eligibility.price) === null || _response$data$eligib6 === void 0 ? void 0 : _response$data$eligib6.experiment) !== null && _response$data$eligib5 !== void 0 ? _response$data$eligib5 : 'BASE',
              catalogItemSource: 'RECURLY',
              productName: response.data.productFamily,
              annotation: _objectSpread(_objectSpread({}, request.itemAnnotations), response.data.eligibility.annotation),
              quantity: 1
            });
          }
          _context3.next = 19;
          break;
        case 16:
          _context3.prev = 16;
          _context3.t0 = _context3["catch"](9);
          captureError({
            error: _context3.t0,
            location: USE_PRICING_ERROR_LOCATION,
            severity: Severity.ERROR
          }, {
            teamName: TeamInfo['FT-CommerceWeb'].name
          });
        case 19:
          return _context3.abrupt("return", {
            items: items,
            successUrl: successUrl,
            errorUrl: errorUrl,
            externalId: externalId,
            action: finalAction,
            authorization: authorizeParams,
            eligibility: pricingData,
            hostAnnotations: hostAnnotations,
            price: price !== null && price !== void 0 ? price : null,
            productType: productFamily,
            products: products
          });
        case 20:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[9, 16]]);
  }));
  return function createCheckoutDCO1ClickReturnPayload(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Convers a Subscription DGS MyLatestSubscriptionsV1WithMop to a Pricing SDK MopDetails.
 * @param subsWithMop MyLatestSubscriptionsV1WithMop
 * @returns MopDetails
 */
var myLatestSubscriptionsV1ToMopDetails = function myLatestSubscriptionsV1ToMopDetails(subsWithMop) {
  var _subsWithMop$myLatest;
  var methodOfPayment = (_subsWithMop$myLatest = subsWithMop.myLatestSubscriptionsV1) === null || _subsWithMop$myLatest === void 0 || (_subsWithMop$myLatest = _subsWithMop$myLatest.cheggStudy) === null || _subsWithMop$myLatest === void 0 || (_subsWithMop$myLatest = _subsWithMop$myLatest.subscription) === null || _subsWithMop$myLatest === void 0 ? void 0 : _subsWithMop$myLatest.methodOfPayment;
  if (!methodOfPayment) return null;
  var id = methodOfPayment.id,
    isPrimary = methodOfPayment.isPrimary,
    isBackup = methodOfPayment.isBackup,
    mopInfo = methodOfPayment.mopInfo,
    valid = methodOfPayment.valid,
    user = methodOfPayment.user;
  var card = mopInfo.card,
    type = mopInfo.type;
  var active = isPrimary || isBackup;
  var _ref5 = card || {},
    cardType = _ref5.cardType,
    expMonth = _ref5.expMonth,
    expYear = _ref5.expYear,
    last4 = _ref5.last4;
  return _objectSpread(_objectSpread({
    active: active,
    canUpdate: false,
    uuid: user.uuid,
    cardId: id,
    cardIdHash: id,
    description: getMopDescription(subsWithMop),
    inApp: false,
    canDisable: false,
    createdDate: 0,
    type: cardType || '',
    last4: last4 || '',
    month: expMonth ? expMonth.toString() : '',
    year: expYear ? expYear.toString() : '',
    isExpired: false,
    isValidPaymentMethod: valid,
    vpa: ''
  }, mapAccountType(type)), {}, {
    billingAddress: getBillingAddress(subsWithMop)
  });
};

/**
 * Convers a Subscription DGS MyLatestSubscriptionsV1WithMop to a Pricing SDK OrderDetails.
 * @param subsWithMop MyLatestSubscriptionsV1WithMop
 * @returns MopDetails
 */
var myLatestSubscriptionsV1ToOrderDetails = function myLatestSubscriptionsV1ToOrderDetails(subsWithMop) {
  var _subsWithMop$myLatest2, _subsWithMop$myLatest3, _subsWithMop$myLatest4;
  var _ref6 = ((_subsWithMop$myLatest2 = subsWithMop.myLatestSubscriptionsV1) === null || _subsWithMop$myLatest2 === void 0 ? void 0 : _subsWithMop$myLatest2.cheggStudy) || {},
    subscription = _ref6.subscription;
  if (!subscription) return null;
  var id = subscription.id,
    createdAt = subscription.createdAt,
    renewalAt = subscription.renewalAt,
    resumeAt = subscription.resumeAt,
    pausedAt = subscription.pausedAt,
    expiredAt = subscription.expiredAt,
    targetPauseAt = subscription.targetPauseAt,
    expirationAt = subscription.expirationAt,
    subscriptionPurchaseInfo = subscription.subscriptionPurchaseInfo,
    vendorPlan = subscription.vendorPlan;
  var totalRenewalPrice = getTotalRenewalPrice(subsWithMop);
  var _ref7 = vendorPlan || {},
    billingPeriod = _ref7.billingPeriod;
  var purchasePrice = subscriptionPurchaseInfo.purchasePrice,
    currencyCode = subscriptionPurchaseInfo.currencyCode;
  var mopDetails = myLatestSubscriptionsV1ToMopDetails(subsWithMop);
  var status = legacySubscriptionStatus((_subsWithMop$myLatest3 = subsWithMop.myLatestSubscriptionsV1) === null || _subsWithMop$myLatest3 === void 0 ? void 0 : _subsWithMop$myLatest3.cheggStudy);
  var renewalDate = renewalAt || resumeAt || expirationAt;
  if (status === 'pendingPause') {
    renewalDate = targetPauseAt;
  }
  return {
    lineItem: {
      createdDate: createdAt,
      id: id,
      orderUuid: id,
      status: status,
      itemType: legacyCatalogItemType((_subsWithMop$myLatest4 = subsWithMop.myLatestSubscriptionsV1) === null || _subsWithMop$myLatest4 === void 0 ? void 0 : _subsWithMop$myLatest4.cheggStudy)
    },
    orderUuid: id,
    orderDate: createdAt,
    orderId: id,
    mopDetails: mopDetails,
    details: {
      renewalDate: renewalDate,
      renewalDateWithFormat: renewalDate,
      suspendDate: pausedAt,
      suspendDateWithFormat: pausedAt,
      cancelledDate: status == 'pendingCancel' ? expirationAt : expiredAt,
      cancelledDateWithFormat: expiredAt,
      renewalPeriod: 1,
      renewalPeriodUnit: 'MONTHS',
      renewalPeriodPrice: purchasePrice.toString(),
      billingPeriod: billingPeriod,
      renewalPrice: purchasePrice,
      renewalPriceWithFormat: formatCurrency(purchasePrice, currencyCode) || undefined,
      renewalPriceWithCurrency: formatCurrency(purchasePrice, currencyCode) || undefined,
      totalRenewalPrice: totalRenewalPrice,
      totalRenewalPriceWithCurrency: formatCurrency(totalRenewalPrice, currencyCode) || undefined,
      orderUuid: id
    },
    paymentMethod: mopDetails !== null && mopDetails !== void 0 && mopDetails.cardId ? {
      id: mopDetails.cardId,
      type: mopDetails.type,
      hash: mopDetails.cardIdHash
    } : null
  };
};

/**
 * Method for generating a GetNextInteractionResponse for RECURLY users.
 * @param request GetNextInteractionRequest
 * @returns Promise<GetNextInteractionResponse>
 */
var nextInteractionResponse = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(request, apolloClient, teamName) {
    var pricingData, interactions, vendorType, finalActions, authState, finalAction, payload;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          pricingData = request.pricingData, interactions = request.interactions;
          vendorType = pricingData.vendorType, finalActions = pricingData.eligibility.finalActions, authState = pricingData.authState;
          finalAction = finalActions !== null && finalActions !== void 0 && finalActions.length ? finalActions[0] : '';
          payload = null;
          if (![UserSubscriptionAction.JOIN.toString(), UserSubscriptionAction.RESUBSCRIBE.toString()].includes(finalAction)) {
            _context4.next = 11;
            break;
          }
          _context4.next = 8;
          return createCheckoutDCO1ClickReturnPayload(request, apolloClient);
        case 8:
          payload = _context4.sent;
          _context4.next = 20;
          break;
        case 11:
          if (![UserSubscriptionAction.RESUME.toString(), UserSubscriptionAction.REVOKE_PENDING_CANCEL.toString(), UserSubscriptionAction.REVOKE_PENDING_PAUSE.toString()].includes(finalAction)) {
            _context4.next = 19;
            break;
          }
          _context4.next = 14;
          return createOrderManagementDCO1ClickReturnPayload(request, apolloClient, teamName);
        case 14:
          payload = _context4.sent;
          if (payload) {
            _context4.next = 17;
            break;
          }
          throw new Error('Failed to create Order Management DCO1ClickReturnPayload');
        case 17:
          _context4.next = 20;
          break;
        case 19:
          return _context4.abrupt("return", {
            data: null,
            errors: []
          });
        case 20:
          return _context4.abrupt("return", {
            data: {
              action: interactions[0],
              reason: '',
              uuid: authState.uuid,
              loginState: authState.state,
              payload: payload,
              vendorType: vendorType
            },
            errors: []
          });
        case 23:
          _context4.prev = 23;
          _context4.t0 = _context4["catch"](0);
          sendCommerceNewRelicError({
            error: "Error fetching product recommendation: ".concat(JSON.stringify(_context4.t0)),
            componentName: ProjectName,
            componentVersion: ''
          });
          return _context4.abrupt("return", {
            data: null,
            errors: [{
              code: 'PRSUTIL-000',
              message: _context4.t0.message,
              type: ErrorType.SERVER
            }]
          });
        case 27:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 23]]);
  }));
  return function nextInteractionResponse(_x7, _x8, _x9) {
    return _ref8.apply(this, arguments);
  };
}();
export { getNextInteraction, nextInteractionResponse, myLatestSubscriptionsV1ToMopDetails };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/PRSUtils/nextInteraction.js
// module id = 4157
// module chunks = 11